import {
  getItemsForCategory,
  menuCategories,
  getLocalized,
} from "./menu";

/** Printed étlap board — editorial grid matching drinks style. */
export const foodsBoardSlots = [
  { id: "brunch", area: "brunch", sketch: "plate", columns: 1 },
  { id: "sandwiches", area: "sandwiches", sketch: "none", columns: 1 },
  { id: "tapas", area: "tapas", sketch: "none", columns: 1 },
  { id: "bowls", area: "bowls", sketch: "bowl", columns: 1 },
  { id: "waffles", area: "waffles", sketch: "none", columns: 1 },
  { id: "dessert", area: "dessert", sketch: "none", columns: 1 },
];

export function getFoodPanel(slot, lang) {
  const category = menuCategories.find((c) => c.id === slot.id);
  if (!category) return null;
  return {
    ...slot,
    category,
    title: getLocalized(category.label, lang),
    note: getLocalized(category.note, lang),
    items: getItemsForCategory(slot.id),
    showDescriptions: true,
  };
}

export function getFoodsBoardPanels(lang) {
  return foodsBoardSlots
    .map((slot) => getFoodPanel(slot, lang))
    .filter(Boolean);
}
